import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-apps-device-signal";

@Injectable({
  providedIn: "root",
})
export class AccountAppDeviceSignalHandlerService {
  constructor(private APIService: ApiService) {}

  redemptionsGet(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      facility_id?: number[];
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    console.log('QS redemptionsGet')
    return this.APIService.get(
      `${PATH}/${masterAccountID}/app/${accountAppID}/redemptions`,
      { params: queryParams },
    );
  }

}